import { Environment } from './environment.model';

export const environment: Environment = new Environment({
  production: false,
  statistics: true,
  apiHost: 'https://tarrafb2b.fmd.dev',
});
